import React from "react";

export default function About() {
  return <h1>hello from about page</h1>;
}
